import { VoEType } from 'src/graphql/types/verificationOfEmployments'

const parseDate = (dateStr: string | null): Date | null => {
  if (!dateStr) return null
  const d = new Date(dateStr)
  return isNaN(d.getTime()) ? null : d
}

export function loadFiltersFromUrl() {
  const searchParams = new URLSearchParams(location.search)

  const filters = {
    tab: null as string | null,
    type: VoEType.INBOUND,
    statuses: [] as string[],
    searchText: '',
    createdAt: {
      gte: null as Date | null,
      lte: null as Date | null,
    },
    assigneeIds: [] as string[],
    minContactAttempts: null as number | null,
    maxContactAttempts: null as number | null,
    lastContactDate: {
      gte: null as Date | null,
      lte: null as Date | null,
    },
    employmentStartDate: {
      gte: null as Date | null,
      lte: null as Date | null,
    },
    employmentEndDate: {
      gte: null as Date | null,
      lte: null as Date | null,
    },
    applicantStages: [] as string[],
    contactInfoFilter: [] as string[],
    consentFilter: [] as string[],
    responseFilter: [] as string[],
    nextActionFilter: [] as string[],
    neverContacted: false,
    sortField: null as string | null,
    sortDirection: null as 'asc' | 'desc' | null,
    hiringStageTab: null as string | null,
  }

  const tab = searchParams.get('tab')
  if (tab) filters.tab = tab

  const statuses = searchParams.get('statuses')
  if (statuses) filters.statuses = statuses.split(',').filter(Boolean)

  const searchText = searchParams.get('searchText')
  if (searchText) filters.searchText = searchText

  const assigneeIds = searchParams.get('assigneeIds')
  if (assigneeIds) filters.assigneeIds = assigneeIds.split(',').filter(Boolean)

  const minContactAttempts = searchParams.get('minContactAttempts')
  if (minContactAttempts !== null) {
    const parsed = parseInt(minContactAttempts, 10)
    if (!isNaN(parsed)) filters.minContactAttempts = parsed
  }

  const maxContactAttempts = searchParams.get('maxContactAttempts')
  if (maxContactAttempts !== null) {
    const parsed = parseInt(maxContactAttempts, 10)
    if (!isNaN(parsed)) filters.maxContactAttempts = parsed
  }

  filters.createdAt.gte = parseDate(searchParams.get('createdAtGte'))
  filters.createdAt.lte = parseDate(searchParams.get('createdAtLte'))

  filters.lastContactDate.gte = parseDate(
    searchParams.get('lastContactDateGte')
  )
  filters.lastContactDate.lte = parseDate(
    searchParams.get('lastContactDateLte')
  )

  filters.employmentStartDate.gte = parseDate(
    searchParams.get('employmentStartDateGte')
  )
  filters.employmentStartDate.lte = parseDate(
    searchParams.get('employmentStartDateLte')
  )
  filters.employmentEndDate.gte = parseDate(
    searchParams.get('employmentEndDateGte')
  )
  filters.employmentEndDate.lte = parseDate(
    searchParams.get('employmentEndDateLte')
  )

  const applicantStages = searchParams.get('applicantStages')
  if (applicantStages)
    filters.applicantStages = applicantStages.split(',').filter(Boolean)

  const contactInfoFilter = searchParams.get('contactInfoFilter')
  if (contactInfoFilter)
    filters.contactInfoFilter = contactInfoFilter.split(',').filter(Boolean)

  const consentFilter = searchParams.get('consentFilter')
  if (consentFilter)
    filters.consentFilter = consentFilter.split(',').filter(Boolean)

  const responseFilter = searchParams.get('responseFilter')
  if (responseFilter)
    filters.responseFilter = responseFilter.split(',').filter(Boolean)

  const nextActionFilter = searchParams.get('nextActionFilter')
  if (nextActionFilter)
    filters.nextActionFilter = nextActionFilter.split(',').filter(Boolean)

  const neverContacted = searchParams.get('neverContacted')
  if (neverContacted === 'true') filters.neverContacted = true

  const sortField = searchParams.get('sortField')
  if (sortField) filters.sortField = sortField

  const sortDirection = searchParams.get('sortDirection')
  if (sortDirection === 'asc' || sortDirection === 'desc') {
    filters.sortDirection = sortDirection
  }

  const hiringStageTab = searchParams.get('hiringStageTab')
  if (hiringStageTab) filters.hiringStageTab = hiringStageTab

  return filters
}
